<template>
  <article id="contact" v-appear="{ delay: 200 }" class="layout-section -split -top -relative">
    <section class="layout-section__split -small">
      <h2 class="layout-section__title">{{ $t('home.contact.title') }}</h2>
      <p>{{ $t('home.contact.content') }}</p>
    </section>

    <section class="layout-section__split -large">
      <HomeContactForm />
    </section>
  </article>
</template>

<script>
import HomeContactForm from './HomeContactForm.vue'

export default {
  name: 'HomeContact',
  components: { HomeContactForm }
}
</script>
